import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // primary auth: httpOnly cookies
});

// In-memory bearer token for cases where third-party cookies are blocked.
// Never persisted to localStorage/sessionStorage (XSS-safe by design).
let bearer = null;

export const setAuthToken = (token) => {
  bearer = token || null;
};

export const getToken = () => bearer;

api.interceptors.request.use((config) => {
  if (bearer) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${bearer}`;
  }
  return config;
});

// Files are served via httpOnly cookies on same-origin requests (img/anchor tags).
export const fileUrl = (id) => `${API_BASE}/files/${id}`;
export const publicProductImageUrl = (id) => `${API_BASE}/public/product-images/${id}`;
export const publicTenantLogoUrl = (id) => `${API_BASE}/public/tenant-logos/${id}`;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
